import React, { useEffect, useState } from "react";
import { manualPaymentAction, setQuantity } from "../../actions/stripe";
import { useDispatch, useSelector } from "react-redux";
import { CURRENCY, GOLD_GRAM_QUANTITY_LIST, GOLD_QUANTITY_LIST, PRODUCT_BULLION_TYPE, PRODUCT_GOLD_TYPE, SUBSCRIPTION_MODULE_TYPE } from "../../constants";
import { Controller, useForm } from "react-hook-form";
import debounce from "debounce";
import Currency from "../currency";
import CurrencyFormat from "../currencyFormat/currencyFormat";

export default function ProductQuantity() {
  const dispatch = useDispatch()
  const { stripePlans, isOverrideProduct, stripeType, savedbankInfoDetails, isManualPayment, isManualQuantity, manualQuantity } = useSelector(state => state.stripe);
  const [input, setinput] = useState(false)
  const {
    control,
    formState: { errors },
    setValue,
    getValues,
    trigger,
    watch,
  } = useForm({
    defaultValues: {
      saveInfo: 'true',
      quantity: GOLD_QUANTITY_LIST[0],
    },
    mode: 'onChange',
  });
  const quantityWatch = watch("quantity")
  const amonutWatch = watch("baseAmountRate")

  const onApplyQty = (data, type) => {
    setValue('quantity', data);
    trigger("quantity")
    dispatch(setQuantity(data))
    if (type) {
      setinput(false)
    }
  };

  const quantityOption = () => {
    // if (stripePlans?.goldProductType?.value === PRODUCT_GOLD_TYPE.KILOGRAM && stripePlans?.productBullionType?.value === PRODUCT_BULLION_TYPE.GOLD) {
      if ([CURRENCY.INR, CURRENCY.CNY].includes(savedbankInfoDetails?.currency?.value)) {
        return GOLD_QUANTITY_LIST.slice(0, 1);
      } else {
        return GOLD_QUANTITY_LIST.slice(0, 5);
      }
    // } else {
    //   return GOLD_QUANTITY_LIST;
    // }
  };

  const imagePaths = {
    usd: ('assets/img/usd.png'),
    sgd: ('assets/img/sgd.png'),
    inr: ('assets/img/inr.png'),
    pkr: ('assets/img/pkr.png'),
    lkr: ('assets/img/lkr.png'),
    bdt: ('assets/img/bdt.png'),
    cny: ('assets/img/cny.png'),
    // Add more values as needed
  };

  useEffect(() => {
    setValue("baseAmountRate", isManualPayment)
  }, [setValue])


  const imagePath =
    imagePaths[stripePlans?.currency?.value] || ('assets/img/usd.png');

  const handleInputChange = value => {
    dispatch(manualPaymentAction(value ? value : 0));
  };

  const debouncedHandleInputChange = debounce(handleInputChange, 500);

  const handleInputStripeAmount = e => {
    e.target.value = e.target.value.replace(/[^0-9.]/g, "");
    debouncedHandleInputChange(e.target.value.length > 0 ? e.target.value : 0); // Call the debounced function
  };

  const openCustomInput = () => {
    setinput(true)
  }

  useEffect(() => {
    if (isManualQuantity) {
      openCustomInput()
      onApplyQty({ label: manualQuantity, value: manualQuantity }, false);
    }
  }, [isManualQuantity, manualQuantity])

  return (
    <>
      <div className="container">
        <div className="row buyProductSectionBg">
          <div className="col-md-12">
            {(isOverrideProduct && stripePlans?.goldProductType?.value !== PRODUCT_GOLD_TYPE.HEDGEKILOGRAM) &&
              <div className="quantitySection">
                <h5 className="m-0">Select quantity</h5>
                <div className="selectQuantitySection customScrollQuantity">
                  {quantityOption().map((info, index) => (
                    <div onClick={() => onApplyQty(info, true)} key={index} className={`${info.value === getValues("quantity").value ? "active" : ""} selectQuantity`}>
                      <p>{info.label}</p>
                      <span> {stripePlans?.goldProductType?.value === PRODUCT_GOLD_TYPE.GRAM ? "Gram" : stripePlans?.goldProductType?.value === PRODUCT_GOLD_TYPE.OUNCE ? "oz" : "Kilogram"}</span>
                    </div>
                  ))}
                  {((stripePlans?.goldProductType?.value === PRODUCT_GOLD_TYPE.KILOGRAM &&
                    stripePlans?.productBullionType?.value === PRODUCT_BULLION_TYPE.SILVER)
                    ||
                    (stripePlans?.goldProductType?.value === PRODUCT_GOLD_TYPE.GRAM)) &&
                    <div onClick={openCustomInput} className={`${input ? "active" : ""} selectQuantity`}>
                      <p>Custom</p>
                    </div>}
                </div>
                {input &&
                  <div className="mt-4 quantitySection">
                    <h5>Enter custom quantity</h5>
                    <div className="selectedAmountSection">
                      <input
                        maxLength={20}
                        type="number"
                        className="form-control bankTransferField selectedQuantityText border-0"
                        placeholder="Enter quantity"
                        max={1000} // ✅ Prevent typing above 999 on supported browsers
                        onKeyDown={(e) => {
                          // Block: e, E, +, -, .
                          if (["e", "E", "+", "-", "."].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        value={getValues("quantity").value}
                        onInput={(e) => {
                          const raw = e.target.value;
                      
                          // Allow empty value
                          if (raw === "") {
                            onApplyQty({ label: "", value: "" }, false);
                            return;
                          }
                      
                          let value = parseInt(raw, 10);
                      
                          if (value > 1000) {
                            value = 1000;
                            e.target.value = 1000;
                          }
                      
                          onApplyQty({ label: value, value: value }, false);
                        }}
                      />
                    </div>
                  </div>
                }

              </div>
            }

            <div className="quantitySection amountQuantitySection">
              <h5 className="m-0">{parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL || (parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.FUNDS || parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.COMPANYFUNDS) ? "Enter amount" : "Amount"}</h5>
              {(parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL || (parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.FUNDS || parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.COMPANYFUNDS)) ? (
                <>
                  <div className="selectedAmountSection">
                    <Controller
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <input
                          maxLength={20}
                          type="div"
                          className="form-control bankTransferField bankTransferFieldAmount border-0"
                          placeholder="Required"
                          value={value?.toString()}
                          onInput={e => {
                            onChange(e);
                            handleInputStripeAmount(e);
                          }}
                        />
                      )}
                      name="baseAmountRate"
                      rules={{
                        required: {
                          value: true,
                          message: 'Enter amount',
                        },
                      }}
                    />
                    <div className="selectorCountry">
                      <img src={imagePath} alt="country" />
                      <p className="m-0">{stripePlans?.currency?.value}</p>
                    </div>
                  </div>
                  {errors && errors.baseAmountRate && (
                    <span className="errorMessage ">
                      {errors?.baseAmountRate?.message}
                    </span>
                  )}
                  {!errors.baseAmountRate && amonutWatch < 100 &&
                    <span className="errorMessage ">
                      Minimum value must be at least 100
                    </span>
                  }
                </>)
                : (
                  <div className="selectedAmountSection">
                    <p className="m-0 selectedQuantityText">
                      <Currency currency={stripePlans?.currency?.value} />
                      <CurrencyFormat
                        currency={stripePlans?.currency?.value}
                        value={parseFloat(stripePlans?.price) * parseFloat(quantityWatch?.value)}
                        decimal={2}
                      /></p>
                    <div className="selectorCountry">
                      <img src={imagePath} alt="country" />
                      <p className="m-0">{stripePlans?.currency?.value}</p>
                    </div>
                  </div>
                )}
              <h6 className="importantNote">
                Important: This is not the final amount for the transaction.
              </h6>
            </div>

            {/* <div className="eligibleRewardSection">
              <h3 className="eligibleReward">Eligible for the Reward</h3>
              <div className="goldBonus">
                <h2 className="m-0">50g Gold Bonus</h2>
                <h6 className="m-0">Gold</h6>
              </div>
              <p className="eligibleRewardDesc m-0">
                Add more 10 gram more gold and earn 60 gram gold bonus
              </p>
            </div> */}
          </div>
        </div>
      </div >
    </>
  );
}
